export class Mandant {
    id: number;
    title: string;
    test: boolean;

    countPatients: number;
    countUsers: number;
    countOperators: number;
}
